module.exports = __webpack_public_path__ + "static/media/email.2adcf886.svg";